import { getCustomDateFilterOptions, getRecentDateFilterOptions } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { getNumberRangeFilterOptions } from "@components/common/faro-table/faro-table-filter/number-range-filter/number-range-filter-utils";
import { GROUPS_MANAGERS_FILTER_COLUMN, GROUPS_PROJECTS_FILTER_COLUMN } from "@components/groups/groups-filters/groups-filter-constants";
import { countGroupMembersByRole, getProjectNumbersInGroup } from "@utils/group-utils";

/**
 * Returns the filter options of the column. The number ranges, dates and date ranges the user
 * picks are options of their own, so the ones among the given filter IDs are included.
 */
export function getGroupsFilterOptions(column, filterIds) {
  if (column === GROUPS_PROJECTS_FILTER_COLUMN) {
    return getNumberRangeFilterOptions(filterIds, getProjectNumbersInGroup);
  }
  if (column === GROUPS_MANAGERS_FILTER_COLUMN) {
    return getNumberRangeFilterOptions(filterIds, getGroupManagersCount);
  }
  return {
    ...getGroupsCreatedFilterPresets(),
    ...getCustomDateFilterOptions(filterIds, getGroupCreatedTime)
  };
}

/** Returns the filter options for the recent days the groups were created in */
export function getGroupsCreatedFilterPresets() {
  return getRecentDateFilterOptions(getGroupCreatedTime);
}

/** Returns the number of managers of the group, which the members column of the groups table shows */
function getGroupManagersCount(group) {
  return "members" in group ? countGroupMembersByRole(group.members).groupManagers : group.numManagers ?? 0;
}

/** Returns the time the group was created */
function getGroupCreatedTime(group) {
  return group.createdAt;
}